import React from 'react';
import { localStorageHandler } from 'core/services';
import PrivacyPolicyTemplate from './PrivacyPolicyTemplate';
import { ModalParams } from 'core/models';
import { BaasicModal } from 'core/components';
import packageJSON from '../../../../package.json';
import { formatDate, isSuperAdminOrganization } from 'core/utils';

function FooterTemplate({rootStore}) {
	const privacyPolicyModal = new ModalParams();
	const version = localStorageHandler.get('appVersion');
	return (
		<div className="footer__footer">
			<p>
				Copyright 2026 Scanship&trade; v{version}
				{isSuperAdminOrganization(rootStore) ? ` (Deployed: ${formatDate(packageJSON.deployDate, false, 'L')})` : ''}
			</p>
			<div className="push">
				<a onClick={() => privacyPolicyModal.open()}>Privacy Policy</a>
			</div>
			<BaasicModal modalParams={privacyPolicyModal}>
				<PrivacyPolicyTemplate />
			</BaasicModal>
		</div>
	);
}

export default FooterTemplate;
